import {Component, OnInit} from '@angular/core';
import * as moment from "moment";
import {UserService} from '../../../core/services/user.service';
import {StatementsService} from '../statements.service';
import {ActivatedRoute, NavigationExtras, Router} from "@angular/router";
import {GridComponent, PageChangeEvent, RowArgs, SelectAllCheckboxState} from "@progress/kendo-angular-grid";
import {process, SortDescriptor} from "@progress/kendo-data-query";
import {FSInvoiceDialogService} from "../../../core/services/fsinvoice.dialog.service";
import {ExcelService} from "../../../core/services/excel.service";
import {StoreInvoice} from "../../../core/shared/model/StoreInvoice";
import {ReportParams} from "../../../core/shared/model/ReportParams";
import {LoggingService} from "mclane-apptemplate-lib";
import {ExcelExportData} from '@progress/kendo-angular-excel-export';
import {downloadIcon} from "@progress/kendo-svg-icons";
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';
@Component({
  selector: 'app-statements-stores',
  templateUrl: './statement-stores.component.html',
  styleUrls: ['./statement-stores.component.scss'],
  providers: [ExcelService]

})
export class StatementsStoresComponent implements OnInit {

  stores: Array<StoreInvoice>;
  data: any;
  fromDate: string;
  endDate: string;
  selectedRequestType: string;
  selectedInvType: string;
  selectedStartDate: Date;
  selectedEndDate: Date = moment().toDate();
  reportParams: Array<ReportParams> = new Array<ReportParams>();
  selectedParents: Array<string> = new Array<string>();
  selectedStoresMap: Map<string, StoreInvoice> = new Map<string, StoreInvoice>();
  userName: string;
  selectedKeys: string[] = [];
  pageSize: number = 30;
  skip = 0;
  info = true;
  buttonCount = 5;
  type: 'numeric';
  pageSizes: number[] = [20, 40, 60];
  previousNext = true;
  selectAllState: SelectAllCheckboxState = 'unchecked';
  selectAllChecked = false;
  loading: boolean = false;
  invoices: Array<StoreInvoice>;
  masterSelect: boolean = false;
  sort: SortDescriptor[] = [{
    field: 'shipToSiteName',
    dir: 'asc'
  }];
  invList: Array<StoreInvoice>

  constructor(private _userService: UserService, public statementsService: StatementsService, private _route: ActivatedRoute, private _router: Router,
              public fsInvoiceDialog: FSInvoiceDialogService, public excelService: ExcelService, public console: LoggingService, public loadingIndicator: LoadingIndicatorHelper) {
    this.selectedKeys = [];
  }

  get noSelection(): boolean {
    return this.selectedKeys.length === 0;
  }

  ngOnInit() {
    this.loading = true;
    this.selectAllState = this.statementsService.getSelectAllStateStore();
    this.masterSelect = this.statementsService.getMasterStoreSelect();
    this.allRowsSelected(this.selectAllState);
    this.selectedKeys = this._userService.getSelectedStatementStores();

    this.setSelectChecked(this.selectAllState);
    this.selectedStartDate = moment(this._userService.getSelectedStartDate()).toDate();
    this.selectedEndDate = moment(this._userService.getSelectedEndDate()).toDate();
    this.selectedInvType = this._userService.getSelectedInvType();
    this.selectedRequestType = this._userService.getSelectedRequestType();
    this.userName = this._userService.getUserName();
    this.fromDate = moment(this.selectedStartDate).format('YYYY-MM-DD');
    this.endDate = moment(this.selectedEndDate).format('YYYY-MM-DD');
    this.selectedParents = this._userService.getSelectedParents();
    if (this.selectedParents.length > 0) {
      this.loading = true;
      this.statementsService.getStoreSummary(this.selectedParents, this.selectedRequestType, this.selectedInvType, this.fromDate, this.endDate).subscribe(stores => {
        this.stores = stores;
        this.console.log("NO data??",stores);
        this.loading = false;
        this.loadingIndicator.hide();
      }),(err)=>{
        this.fsInvoiceDialog.showErrorMessageDialog("API Error","No stores Data");
        this.loadingIndicator.hide();
      };
    }
    this.exportAllData = this.exportAllData.bind(this);
  }

  refreshForm() {

  }

  backClicked() {
    let navigationExtras: NavigationExtras = {
      queryParams: {}
    };
    this._router.navigate(['/statementparents'], navigationExtras);
  }

  nextClicked() {
    this.refreshForm();


    let navigationExtras: NavigationExtras = {
      queryParams: {}
    };

    if (this.selectedKeys.length == 0) {
      this.fsInvoiceDialog.showMessageDialog('Selection', 'You must make a selection');
    } else {

      this._userService.setSelectedStatementStores(this.selectedKeys);
      this._router.navigate(['/statementinvoices'], navigationExtras);
    }
  };

  setSelectChecked(check: SelectAllCheckboxState) {
    if (check) {
      this.selectAllChecked = true;
    } else {
      this.selectAllChecked = false;
    }
  }

  pageChange({skip, take}: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
  }

  isRowSelected = (e: RowArgs) => this.selectedKeys.includes(e.dataItem.shipToSiteNumber);


  selectionKey(context: RowArgs): string {
    return context.dataItem.shipToSiteNumber;
  }

  tableHeaderCheckBoxChanged(checked: boolean) {
    if (checked) {
    }
  }

  allRowsSelected(selectionObj: any) {
    this.statementsService.setSelectAllStateStore(selectionObj)
    if (selectionObj == 'checked') {
      this.tableHeaderCheckBoxChanged(true);
      this.selectAllState = selectionObj;
    } else if (selectionObj == 'unchecked') {
      this.tableHeaderCheckBoxChanged(false);
      this.selectAllState = selectionObj;
    } else {

      selectionObj.deselectedRows.forEach(row => {
        let index = this.selectedKeys.indexOf(row.dataItem.shipToSiteNumber);
        this.selectedKeys.splice(index, 1);
        this.rowCheckBoxChanged(false, row.dataItem);
      });
      selectionObj.selectedRows.forEach(row => {
        if (!this.selectedKeys.includes(row.dataItem.shipToSiteNumber)) {
          this.selectedKeys.push(row.dataItem.shipToSiteNumber);
          this.rowCheckBoxChanged(true, row.dataItem);
        }
      });
    }
  }

  masterClicked() {
    if (this.masterSelect === false) {
      this.masterSelect = true;
      this.stores.forEach(item => {
        this.selectedKeys.push(item.shipToSiteNumber);
        this.selectedStoresMap.set(item.shipToSiteNumber, item)
      });
    } else {
      this.masterSelect = false;
      this.selectedKeys.length = 0;
      this.selectedStoresMap.clear();
    }
    this.statementsService.setMasterStoreSelect(this.masterSelect);
  }

  rowCheckBoxChanged(checked: boolean, store: StoreInvoice) {
    if (checked) {
      this.selectedStoresMap.set(store.shipToSiteNumber, store);
    } else {
      this.selectedStoresMap.delete(store.shipToSiteNumber);
    }
  }

  viewStatement(): void {
    if (this.selectedKeys.length == 0) {
      this.fsInvoiceDialog.showMessageDialog('Selection', 'You must make a selection');
    } else {
      this._userService.setSelectedStoresMap(this.selectedStoresMap);

      this.statementsService.getStatementReport(this.selectedKeys, this.selectedRequestType, this.selectedInvType, this.fromDate, this.endDate, 'FSC0001A').subscribe(params => {
        this.reportParams = params;

        var mapForm = document.createElement("form");
        mapForm.target = "Map";
        mapForm.method = "POST"; // or "post" if appropriate
        this.reportParams.map(param => {
          if (param.entity == 'action') {
            mapForm.action = param.value;
          } else if (param.entity == 'form name') {
            mapForm.name = param.value;
          } else if (param.entity == 'method') {
            mapForm.method = param.value;
          }


          if (param.type != 'CFM') {
            var mapInput = document.createElement("input");
            mapInput.type = "hidden";
            mapInput.name = param.entity;
            mapInput.value = param.value;
            mapForm.appendChild(mapInput);
          }
        });
        document.body.appendChild(mapForm);
        var win = window.open("", "Map", "status=0,title=0,height=600,width=800,scrollbars=1");

        mapForm.submit();
      });
      this.selectedKeys = [];
      this.selectAllState = 'unchecked';
      this.masterSelect = false;
    }
  }

  public exportAllData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.invList, {}).data
    };
    return result;
  }

  invoiceResults(bulkGrid: GridComponent) {
    this.loading = true;
    this.statementsService.getInvoiceSummary(this.selectedKeys, this.selectedRequestType, this.selectedInvType, this.fromDate, this.endDate).subscribe(invoices => {
      this.invoices = invoices;
      let tempDiscAmt = 0;
      this.invList = this.invoices.map(item => {
        if (item.origBalance < 0) {
          tempDiscAmt = +Math.abs(item.discountAmount);
        } else {
          tempDiscAmt = -Math.abs(item.discountAmount);
        }
        item.amount = item.dueBalance - item.discountAmount;
        item.discountAmount = tempDiscAmt;
        return item;
      })
    }).add(() => {
      this.loading = false;
      var furtherInfo: Array<string> = new Array<string>();
      furtherInfo.join('info');
      this.fsInvoiceDialog.showConfirmationDialogWithFurtherInfo('Download', 'You have selected ' + this.selectedKeys.length + ' store(s) for downloading `Do you wish to continue?`', furtherInfo, () => {
        try {
          this.loading = true;
          setTimeout(() => {
            bulkGrid.saveAsExcel();
            this.loading = false;
          }, 100);
        } catch (ex) {
          this.loading = false;
        }
      }, () => {
      });
    });
  }

  exportAsXLSX(bulkGrid: GridComponent) {

    if (this.selectedKeys.length == 0) {
      this.fsInvoiceDialog.showMessageDialog('Selection', 'You must make a selection');
    } else {
      this._userService.setSelectedStatementStores(this.selectedKeys);
      this.invoiceResults(bulkGrid);
    }
  }


  protected readonly downloadIcon = downloadIcon;
}




